import { Box } from '@mui/material'
import useHandleComponent from '../../hooks/useHandleComponent'
import { StepEnum } from './types'

const Content = ({
  currentStep,
  isMobileDevice,
}: {
  currentStep: StepEnum
  isMobileDevice?: boolean
}) => {
  const { render } = useHandleComponent()

  return isMobileDevice ? (
    render(currentStep)
  ) : (
    <Box width={'85%'} paddingLeft={'5%'}>
      {render(currentStep)}
    </Box>
  )
}

export default Content
